module.exports = __webpack_public_path__ + "static/media/video_thumb1.c3d0af8a.svg";